module.exports = __webpack_public_path__ + "img/calculator.9c5e2ce6.svg";